/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, NotificationEmailDeliveriesControllerEmailPreviewPathParams, NotificationEmailDeliveriesControllerEmailPreview400, NotificationEmailDeliveriesControllerEmailPreview401, NotificationEmailDeliveriesControllerEmailPreview403, NotificationEmailDeliveriesControllerEmailPreview404 } from "../../models/notificationEmailDeliveriesController/NotificationEmailDeliveriesControllerEmailPreview";

function getNotificationEmailDeliveriesControllerEmailPreviewUrl(id: NotificationEmailDeliveriesControllerEmailPreviewPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/notification-email-deliveries/${id}/email-preview` as const }  
  return res
}

/**
 * @description Renders the envelope's current members for any status. Not a replay of what was sent: send-time eligibility (read state, per-event OFF, the master switch) is deliberately not applied. Mutates nothing.
 * @summary Preview the email a delivery renders to, without sending it
 * {@link /api/v1/notification-email-deliveries/:id/email-preview}
 */
export async function notificationEmailDeliveriesControllerEmailPreview(id: NotificationEmailDeliveriesControllerEmailPreviewPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationEmailDeliveriesControllerEmailPreviewQueryResponse, ResponseErrorConfig<NotificationEmailDeliveriesControllerEmailPreview400 | NotificationEmailDeliveriesControllerEmailPreview401 | NotificationEmailDeliveriesControllerEmailPreview403 | NotificationEmailDeliveriesControllerEmailPreview404>, unknown>({ method : "GET", url : getNotificationEmailDeliveriesControllerEmailPreviewUrl(id).url.toString(), ... requestConfig })  
  return res.data
}